<template>
    <div v-if="!state.loading">
        <div class="pgehd">
            <h2>Assignments for {{subject_name}}</h2>
            <div class="pgectr">
                <span class="pgebtn" @click="createnew">
                    Add Assignment
                </span>
            </div>
        </div>
        
        <PrimeDataTable
            :value="list"
            :rows="10"
            responsiveLayout="scroll"
            stripedRows>
            
            <PrimeColumn field="sn" header="sn" />
            <PrimeColumn field="name" header="Name" />
            <PrimeColumn field="grade" header="Group" />
            <PrimeColumn field="status" header="Status" />
            <PrimeColumn field="date" header="Submission" />
            <PrimeColumn header="Options">
                <template #body="slotProps">
                    <div class="flex gap-2">
                        <PrimeButton
                            label="Questions"
                            icon="pi pi-bars"
                            class="p-button-rounded p-button-text"
                            @click="questions(slotProps.data)"
                        />
                        <PrimeButton
                            label="Mark"
                            icon="pi pi-check"
                            class="p-button-rounded p-button-text"
                            @click="assignment(slotProps.data)"
                        />
                    </div>
                </template>
            </PrimeColumn>
        </PrimeDataTable>
    </div>
    <div v-else class="loader">
        <img src="@/assets/img/ajldr.gif" />
    </div>

    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="1"
            :fields="createFields" @submit="addAssignment"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRouter, useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AssignmentView",
    components:{ModalView,DynamicForm},
    setup(){
        const route = useRoute();
        const subject = computed(() => route.params.sub);
        const group = computed(() => route.params.group);
        const router = useRouter();
        const state=reactive({loading:true, createModal:false,
            submitting:false,error:[],success:false})
        const list = ref([])
        const globalFilter=ref("");
        const subject_name=ref("");
        const createFields=ref([
            { name: "Add Assignment", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                    { type: 'date', name: 'date', label: 'Deadline',
                        value: ""  },
                    {type: 'hidden', name: 'subject',
                        value: subject.value},
                    {type: 'hidden', name: 'group',
                        value: group.value}
                ]
            }
        ])

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            var data={
                getAssignmentList:subject.value, 
                group_id:group.value
            }
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        subject_name.value=res.msg.subject
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function assignment(row){
            router.push({ name: 'submissionlist', params:{id:row.id}});
        }

        function questions(row){
            router.push({ name: 'assignmentquestions', params:{id:row.id}});
        }

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }

        function addAssignment(data){
            state.submitting=true;
            state.errors=[];
            data.addAssignment="";
            state.success=false;
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }
        
        return {list,globalFilter, state,assignment,createFields,
            createnew,addAssignment,questions,subject_name
        } 
    }
}
</script>